import { gql } from '@apollo/client';

export const TOGGLE_INTERESTED = gql`
  mutation TOGGLE_INTERESTED($projectId: String!) {
    toggleInterested(projectId: $projectId) {
      __typename
      author {
        id
        email
        profile {
          id
          name
          bio
          website
        }
      }

      id
      type
      title
      locations {
        id
        name
      }
      visibility
      description
      fundingStatus

      medias {
        id
        fileUrl
      }

      projectStatus
      genres {
        id
        name
      }
      progress

      likes {
        id
      }
      wasLikedByUser

      comments {
        id
        contentJson
      }
    }
  }
`;
